<!-- Hero Section -->

<!-- <section class="relative bg-cover bg-center h-[50vh] md:h-[60vh] text-white" [style.background-image]="'url('+'/assets/images/bg-becomevendor.png'+')'"> -->
<section class="relative bg-cover h-[60vh] md:h-[70vh] text-white overflow-hidden" [style.background-image]="'url(' + heroImage() + ')'" style="background-position: center 35%;">
    <div class="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/70"></div>
    <div class="relative container mx-auto px-4 sm:px-6 lg:px-8 h-full flex flex-col justify-center items-center text-center">
        <h1 class="text-4xl md:text-6xl font-bold leading-tight drop-shadow-lg">{{ cText().hero.title }}</h1>
        <p class="mt-4 text-lg md:text-xl max-w-2xl drop-shadow-md">{{ cText().hero.subtitle }}</p>
        <div class="mt-8">
            <button (click)="signUp('register')" class="px-8 py-3 text-lg font-semibold text-primary bg-white rounded-lg shadow-lg hover:bg-gray-100 transition-transform hover:scale-105 cursor-pointer">
                {{ cText().hero.cta }}
            </button>
        </div>
    </div>
</section>

<!-- Why Transform Section -->
<section class="py-16 sm:py-24 bg-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center max-w-3xl mx-auto">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ cText().whyTransform.title }}</h2>
            <p class="mt-4 text-lg leading-8 text-gray-600">{{ cText().whyTransform.subtitle }}</p>
        </div>
        <div class="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-y-12 gap-x-8 text-center">
            @for(item of cText().whyTransform.features; track item.title) {
            <div>
                <div class="flex items-center justify-center h-16 w-16 rounded-full bg-gray-100 mx-auto" [innerHTML]="item.icon | safeHtml"></div>
                <h3 class="mt-5 text-md font-semibold text-gray-900">{{ item.title }}</h3>
                <p class="mt-1 text-sm text-gray-600">{{ item.description }}</p>
            </div>
            }
        </div>
    </div>
</section>

<!-- Core Features Section -->
<section class="py-16 sm:py-24 bg-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center max-w-3xl mx-auto">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ cText().coreFeatures.title }}</h2>
        </div>
        <div class="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            @for(feature of cText().coreFeatures.features; track feature.title) {
            <div class="bg-white p-8 rounded-xl shadow-md transition-shadow hover:shadow-lg text-center sm:text-left rtl:sm:text-right">
                <div class="flex items-center justify-center sm:justify-start h-12 w-12 rounded-lg bg-gray-100 mb-6 mx-auto sm:mx-0" [innerHTML]="feature.icon | safeHtml"></div>
                <h3 class="text-lg font-bold text-gray-900">{{ feature.title }}</h3>
                <p class="mt-2 text-base text-gray-600">{{ feature.description }}</p>
            </div>
            }
        </div>
    </div>
</section>

<!-- How It Works Section -->
<section class="py-16 sm:py-24 bg-gray-50">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ cText().howItWorks.title }}</h2>
            <p class="mt-4 text-lg leading-8 text-gray-600">{{ cText().howItWorks.subtitle }}</p>
        </div>
        <div class="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            @for(step of cText().howItWorks.steps; track step.title) {
            <div class="p-8 bg-white rounded-xl shadow-md">
                <div class="flex items-center justify-center h-12 w-12 rounded-full bg-primary text-white mx-auto" [innerHTML]="step.icon | safeHtml"></div>
                <h3 class="mt-5 text-lg font-semibold text-gray-900">{{ step.title }}</h3>
                <p class="mt-2 text-base text-gray-600">{{ step.description }}</p>
            </div>
            }
        </div>
    </div>
</section>

<!-- FAQ Section -->
<section class="py-16 sm:py-24 bg-white">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center max-w-3xl mx-auto">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ cText().faq.title }}</h2>
            <p class="mt-4 text-lg leading-8 text-gray-600">{{ cText().faq.subtitle }}</p>
        </div>
        <div class="mt-12 max-w-3xl mx-auto">
            <div class="space-y-4">
                @for(item of cText().faq.questions; track item.q; let i = $index) {
                <div class="border-b border-gray-200 pb-4">
                    <button (click)="toggleFaq(i)" class="w-full flex justify-between items-center text-left rtl:text-right text-lg font-semibold text-gray-800 hover:text-primary">
                        <span>{{ item.q }}</span>
                        <span class="transition-transform duration-300" [class.rotate-45]="openFaqIndex() === i">+</span>
                    </button>
                    @if(openFaqIndex() === i) {
                    <div class="mt-3 text-gray-600 leading-relaxed animate-fade-in">
                        {{ item.a }}
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </div>
</section>

<!-- Gulf Expansion Section -->
<section class="py-16 sm:py-24 bg-gray-50">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ cText().gulfExpansion.title }}</h2>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            <!-- Bahrain Card -->
            <div class="bg-white border border-gray-200 rounded-xl shadow-lg p-8 h-full">
                <div class="flex items-center space-x-3 rtl:space-x-reverse">
                    <span class="text-green-500" [innerHTML]="cText().gulfExpansion.bahrain.icon | safeHtml"></span>
                    <h3 class="text-2xl font-bold text-gray-900">{{ cText().gulfExpansion.bahrain.title }}</h3>
                    <span class="bg-green-100 text-green-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">{{ cText().gulfExpansion.bahrain.status }}</span>
                </div>
                <p class="mt-4 text-gray-600">{{ cText().gulfExpansion.bahrain.description }}</p>
                <!-- <div class="grid grid-cols-3 gap-4 text-center my-6">
                    @for(stat of cText().gulfExpansion.bahrain.stats; track stat.label) {
                    <div>
                        <p class="text-3xl font-bold text-primary">{{ stat.value }}</p>
                        <p class="text-sm text-gray-500 mt-1">{{ stat.label }}</p>
                    </div>
                    }
                </div> -->
                <ul class="space-y-3 text-gray-700">
                    @for(item of cText().gulfExpansion.bahrain.features; track item) {
                    <li class="flex items-center">
                        <span class="text-green-500 ltr:mr-2 rtl:ml-2" [innerHTML]="cText().gulfExpansion.checkIcon | safeHtml"></span>
                        <span>{{ item }}</span>
                    </li>
                    }
                </ul>
            </div>

            <!-- Saudi Arabia Card -->
            <div class="bg-white border border-gray-200 rounded-xl shadow-lg p-8 h-full">
                <div class="flex items-center space-x-3 rtl:space-x-reverse">
                    <span class="text-blue-500" [innerHTML]="cText().gulfExpansion.saudi.icon | safeHtml"></span>
                    <h3 class="text-2xl font-bold text-gray-900">{{ cText().gulfExpansion.saudi.title }}</h3>
                    <span class="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded-full">{{ cText().gulfExpansion.saudi.status }}</span>
                </div>
                <p class="mt-4 text-gray-600">{{ cText().gulfExpansion.saudi.description }}</p>
                <div class="mt-6">
                    <h4 class="font-semibold text-gray-800">{{ cText().gulfExpansion.saudi.opportunitiesTitle }}</h4>
                    <ul class="space-y-3 mt-3 text-gray-700">
                        @for(item of cText().gulfExpansion.saudi.opportunities; track item) {
                        <li class="flex items-start">
                            <span class="text-blue-500 ltr:mr-2 rtl:ml-2 mt-1" [innerHTML]="cText().gulfExpansion.arrowIcon | safeHtml"></span>
                            <span>{{ item }}</span>
                        </li>
                        }
                    </ul>
                </div>
                <div class="mt-6 bg-gradient-to-r from-blue-50 to-cyan-50 text-blue-800 rounded-lg p-4 flex items-center space-x-4 rtl:space-x-reverse">
                    <span [innerHTML]="cText().gulfExpansion.saudi.promoIcon | safeHtml" class="text-blue-500"></span>
                    <p class="text-sm font-medium">{{ cText().gulfExpansion.saudi.promoText }}</p>
                </div>
            </div>
        </div>

        <!-- Roadmap -->
        <div class="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
            @for(item of cText().gulfExpansion.roadmap; track item.country) {
            <div class="bg-white border border-gray-200 rounded-lg p-4">
                <div class="flex items-center justify-center space-x-2 rtl:space-x-reverse">
                    <span [innerHTML]="item.icon | safeHtml"></span>
                    <p class="font-semibold">{{item.country}}</p>
                </div>
                <p class="text-sm text-gray-500 mt-1">{{item.date}}</p>
            </div>
            }
        </div>
    </div>
</section>

<!-- Final CTA Section -->
<section class="bg-gradient-to-r from-blue-600 to-cyan-500">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
        <h2 class="text-3xl font-bold tracking-tight text-white sm:text-4xl">{{ cText().cta.title }}</h2>
        <p class="mt-4 text-lg leading-8 text-blue-100">{{ cText().cta.subtitle }}</p>
        <div class="mt-8">
            <a [routerLink]="['/vendor-form', 'register']" class="group inline-flex items-center justify-center px-6 py-3 text-base font-semibold text-primary bg-white rounded-lg shadow-md hover:bg-gray-100 transition-colors">
                {{ cText().cta.button }}
                <span class="ltr:ml-2 rtl:mr-2 transition-transform group-hover:ltr:translate-x-1 group-hover:rtl:-translate-x-1" [class.rotate-180]="translateService.currentLang === 'ar'">&rarr;</span>
            </a>
        </div>
    </div>
</section>

<!-- old------------------------------------------------------------------- -->
<div class="become-vendor text-center sm:mb-24 mb-16 hidden">
    <div class="top-side text-white">
        <div class="container pt-16 pb-40 flex flex-col gap-3">
            <div class="sm:text-base text-xs">
                {{ "become_a_vendor_tagline"|translate }}
            </div>
            <div class="sm:text-5xl  text-3xl font-bold">
                {{ "transform_your_business_tagline"|translate }}
            </div>
            <div class="sm:text-2xl text-base">
                {{ "physical_boundaries_tagline"|translate }}
            </div>
            <div class="flex flex-row justify-center">
                <button class="btn btn-primary rounded-full me-2 cbtn red px-4 capitalize" type="button" (click)="signUp('register')">{{ "register_now"|translate }}</button>

                <button class="btn btn-primary rounded-full me-2 cbtn white px-4 capitalize" type="button" (click)="signUp('demo')">{{ "book_a_demo"|translate }}</button>
            </div>
            <div>
                <img src="" />
            </div>
        </div>

    </div>
    <div class="container  bottom-side sm:-mt-48 -mt-32">
        <div class="bottom-header sm:h-48 h-32 flex flex-col justify-center rounded-t-2xl">
            <div class="font-bold sm:text-3xl text-xl">
                {{ "why_transform_into_ecommerce"|translate }}
            </div>
            <div class="text-sm mt-2">
                {{ "become_a_vendor_tagline"|translate }}
            </div>
        </div>
        <div class="bottom-section flex desktop:tablet:flex-row mobile:flex-col flex-wrap justify-center bg-white  p-10">
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/insight.svg"></div>
                <div class="mt-3 text-center text-sm">{{"transform_text_1"|translate}}</div>
            </div>
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/refresh.svg"></div>
                <div class="mt-3 text-center text-sm">{{"transform_text_2"|translate}}</div>
            </div>
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/fast.svg"></div>
                <div class="mt-3 text-center text-sm">{{"transform_text_3"|translate}}</div>
            </div>
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/chart.svg"></div>
                <div class="mt-3 text-center text-sm">{{"transform_text_4"|translate}}</div>
            </div>
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/cart.svg"></div>
                <div class="mt-3 text-center text-sm">{{"transform_text_5"|translate}}</div>
            </div>
        </div>
        <div class="mid-section sm:h-24 h-20 flex flex-col justify-center">
            <div class="font-bold sm:text-3xl text-xl">
                {{ "why_join_qetaat"|translate }}
            </div>
            <div class="text-sm mt-2">
                {{ "transform_your_business_tagline"|translate }}
            </div>
        </div>

        <div class="bottom-section container flex desktop:tablet:flex-row mobile:flex-col flex-wrap justify-center bg-white p-10 pb-20 rounded-b-2xl">
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/vision.svg"></div>
                <div class="mt-3 text-center text-sm">{{"why_join_text_1"|translate}}</div>
            </div>
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/network.svg"></div>
                <div class="mt-3 text-center text-sm">{{"why_join_text_2"|translate}}</div>
            </div>
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/market.svg"></div>
                <div class="mt-3 text-center text-sm">{{"why_join_text_3"|translate}}</div>
            </div>
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/flag.svg"></div>
                <div class="mt-3 text-center text-sm">{{"why_join_text_4"|translate}}</div>
            </div>
            <div class="col-lg col-md-4 mb-4 text-center">
                <div><img class="section-icon" src="assets/svg/vendorform/ecommerce.svg"></div>
                <div class="mt-3 text-center text-sm">{{"why_join_text_5"|translate}}</div>
            </div>
        </div>
    </div>
    <div class="flex flex-row -mt-6  justify-center">
        <!-- <button class="btn btn-primary rounded-full me-2 cbtn red px-4 capitalize" type="button"
            (click)="signUp('register')">{{ "register_now"|translate }}</button> -->
        <button class="btn btn-primary rounded-full me-2 cbtn blue px-4 capitalize" type="button" (click)="signUp('demo')">{{ "book_a_demo"|translate }}</button>
    </div>

    <div #plansEl class="hidden">
        <div class=" sm:h-48 h-32 flex flex-col justify-center rounded-t-2xl">
            <div class="font-bold sm:text-3xl text-xl">
                {{ "choose_your_plan"|translate }}
            </div>
            <div class="text-sm mt-2">
                {{ "choose_your_package"|translate }}
            </div>
        </div>
        <div class="flex justify-center max-w-[14rem] m-auto mb-8 lg:mb-16">
            <div class="relative flex w-full p-1 rounded-full">
                <span class="absolute inset-0 m-1 pointer-events-none" aria-hidden="true">
                    <span class="absolute inset-0 w-1/2 bg-blue-default rounded-full shadow-sm shadow-indigo-950/10 transform transition-transform duration-150 ease-in-out {{isAnnual ? 'ltr:translate-x-0 ' : 'ltr:translate-x-full rtl:translate-x-[-100%]'}}"></span>
                </span>
                <div class="flex cursor-pointer justify-center items-center ring-blue-default relative flex-1 text-sm font-medium h-8 rounded-full focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 transition-colors duration-150 ease-in-out {{isAnnual ? 'text-white' : 'text-slate-500'}}" (click)="isAnnual=true">{{ "annualy"|translate }}</div>
                <div class="flex cursor-pointer justify-center items-center relative flex-1 text-sm font-medium h-8 rounded-full focus-visible:outline-none focus-visible:ring focus-visible:ring-indigo-300 transition-colors duration-150 ease-in-out {{isAnnual ? 'text-slate-500' : 'text-white'}}" (click)="isAnnual=false">{{ "monthly"|translate }}</div>
            </div>
        </div>
        <div class="container mt-2 mb-4 flex flex-col sm:flex-row gap-4" *ngIf="plans">
            @for(plan of plans; track plan){
            <div class="sm:w-1/3 justify-content-center">
                <div class="bg-card-new h-full card-radius-x1">
                    <h4 class="card-header plan-title">{{translateHelper.localize(plan.name)}}</h4>
                    <div class="card-body">
                        <!-- <h3 class="mb-3">{{ "features"|translate }}</h3> -->
                        <div class="flex flex-row items-end mb-3">
                            <div class="leading-[100%] font-bold text-4xl">{{isAnnual?plan.annualy: plan.monthly}}</div>
                            <span class="leading-[100%] text-sm">BHD</span>
                            <span class="leading-[100%] text-gray-default text-sm">/{{isAnnual?'yearly':
                                'monthly'}}</span>
                        </div>
                        <mat-divider class="my-4"></mat-divider>
                        <button class="btn btn-primary m-auto w-1/2 mb-3 rounded-full  cbtn red  capitalize" type="button" [queryParams]="{st : isAnnual?'annualy':'monthly'}" [routerLink]="['/',this.translateService.currentLang,'checkout-s',plan._id,'vendor-subscription']">{{
                            "apply_now"|translate }}</button>

                        <!-- <a class="btn btn-primary m-auto w-1/2 mb-3" (click)="submit()">{{"apply_now"|translate}}!</a> -->
                        <div class="plan-item" *ngFor="let item of plan.features">
                            <div class="details">
                                <div class="title flex justify-start">{{translateHelper.localize(item.name)}}</div>
                                <div class="description">{{translateHelper.localize(item.description)}}</div>
                            </div>
                            <div class="support" [class.active]="item.value">
                                <ng-container *ngIf="isBoolean(item.value); else supportingText;">
                                    <mat-icon>{{item.value ? 'done' : 'close'}}</mat-icon>
                                </ng-container>
                                <ng-template #supportingText>
                                    <b>{{item.value}}</b>
                                </ng-template>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            }

        </div>
    </div>
</div>